<h3 [innerHTML]="block.data.text ? block.data.text : block.data.heading" [attr.id]="parseBlockId(block)"></h3>
